import { MetricsTracker, USER_EVENTS } from '@sm/metrics';

const MAX_RETRIES = 10;
const RETRY_INTERVAL = 250;

declare const window: {
  usabilla_live: ((x: string, y?: unknown) => void) | null;
} & Window;

export function waitForUsabilla(callback: () => void): void {
  const waitForUsabillaLiveToLoad = (retries = 0): void => {
    if (window?.usabilla_live) {
      callback();
      return;
    }
    if (retries >= MAX_RETRIES) {
      // eslint-disable-next-line no-console
      console.warn('Usabilla failed to load after maximum retries');
      return;
    }
    setTimeout(() => waitForUsabillaLiveToLoad(retries + 1), RETRY_INTERVAL);
  };

  waitForUsabillaLiveToLoad();
}

export function activateUsabilla(
  customData?: object,
  hideOnLoad?: boolean
): void {
  waitForUsabilla(() => {
    window?.usabilla_live?.(
      'setEventCallback',
      (_: unknown, action: string) => {
        if (action === 'Feedback:Open') {
          MetricsTracker.track({
            name: USER_EVENTS.ELEMENT_INTERACTION,
            data: {
              actionType: 'button_click',
            },
          });
        }
      }
    );

    if (hideOnLoad) {
      window?.usabilla_live?.('hide');
    } else {
      window?.usabilla_live?.('show');
      if (customData) {
        window?.usabilla_live?.('data', { custom: customData });
      }
    }
  });
}
